import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as fromStore from '../../../store';
import {catchError, map, switchMap, withLatestFrom, concatMap, mergeMap} from 'rxjs/operators';
import { LicenseMgtListActionTypes, LicenseMgtListActions } from '../actions/license-mgt-list.actions';
import {LicenseMgtService} from '../../../services/license-mgt.service';
import {Store} from '@ngrx/store';
import {UpdateInfoModel} from '../../updateInfo/update-info.model';
import {updateInfoType} from '../../../shareModel';
import * as featureActions from '../../index';
import {of} from 'rxjs';
import {LicenseSettingListActionTypes} from '../../index';


@Injectable()
export class LicenseMgtListEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private licenseMgtService = inject(LicenseMgtService);

  constructor() {}

  GetLicenseMgtLists$ = createEffect(() => this.actions$.pipe(
    ofType(LicenseMgtListActionTypes.GetLicenseMgtLists),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const param: any = {
        otp: user.otp,
        confirmTypes: [1, 2]
      };
      if (action.payload && action.payload.acode) {
        param.acode = action.payload.acode;
      }
      return this.licenseMgtService.ReadLicenseMgtList(param).pipe(
        mergeMap((res) => {
          if (res.result && !!res.msg.body && Array.isArray(res.msg.body)) {
            const data = res.msg.body;
            const dcodeList = data.map(item => item.dcode);
            if (action.payload && !action.payload.syncAccountsInfo) {
              return of(
                new featureActions.GetDevices(dcodeList),
                new featureActions.UpserLicenseMgtLists(res.msg.body));
            } else {
              return of(
                new featureActions.GetAccounts(),
                new featureActions.GetDevices(dcodeList),
                new featureActions.UpserLicenseMgtLists(res.msg.body));
            }
          }
          return of(new featureActions.LoadLicenseMgtLists([]));
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.GetLicenseMgtListsFail());
        })
      );
    })
  ));
  DeleteLicenseMgtList$ = createEffect(() => this.actions$.pipe(
    ofType(LicenseMgtListActionTypes.GetDeleteLicenseMgtLists),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]: [any, any]) => {
      const params = {
        otp: user.otp,
        id: action.payload.id
      };
      return this.licenseMgtService.DeleteLicenseMgtList(params).pipe(
        switchMap((res: UpdateInfoModel) => {
          const result = { ...res, type: updateInfoType.DeleteLicenseMgtList };
          if (result.result) {
            return [new featureActions.DeleteLicenseMgtLists({id: params.id}), new featureActions.UpdateInfoSuccessAction(result)];
          } else {
            const errorResult = { ...result, result: false, errmsg: result.msg };
            return [new featureActions.UpdateInfoFailAction(errorResult)];
          }}
        ),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.DeleteLicenseMgtList
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));
  GetLicenseSettingLists$ = createEffect(() => this.actions$.pipe(
    ofType(LicenseSettingListActionTypes.GetLicenseSettingLists),
    map((action: featureActions.GetLicenseSettingLists) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const param = {
        otp: user.otp,
        acode: payload,
        confirmTypes: [1, 2]
      };
      return this.licenseMgtService.ReadLicenseMgtList(param).pipe(
        map((res) => {
          if (res.result && !!res.msg.body && Array.isArray(res.msg.body)) {
            return new featureActions.LoadLicenseSettingLists(res.msg.body);
          }
          return new featureActions.LoadLicenseSettingLists([]);
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.GetLicenseSettingListsFails());
        })
      );
    })
  ));
  BindLicenseSN$ = createEffect(() => this.actions$.pipe(
    ofType(LicenseMgtListActionTypes.GetBindSNToLicenseMgtLists),
    map((action: any) => action.payload),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([payload, user]) => {
      const params = {
        otp: user.otp,
        data: payload
      };
      return this.licenseMgtService.BindLicenseSN(params).pipe(
        switchMap((res: UpdateInfoModel) => {
          const result = { ...res, type: updateInfoType.BindLicenseSN };
          const licenseMgtParam = { syncAccountsInfo: true};
            if (result.result && result.msg['body'] === '') {
              return [new featureActions.GetLicenseMgtLists(licenseMgtParam), new featureActions.UpdateInfoSuccessAction(result)];
            } else {
              const errorResult = { ...result, errmsg: result.msg['body'].join(', ') };
              return [new featureActions.GetLicenseMgtLists(licenseMgtParam), new featureActions.UpdateInfoFailAction(errorResult)];
            }
          }
        ),
        // TODO: catchError Message調整 --> 已完成
        catchError(error => {
          const res: UpdateInfoModel = {
            result: false,
            errmsg: 'Error',
            type: updateInfoType.BindLicenseSN
          };
          return [new featureActions.UpdateInfoFailAction(res)];
        })
      );
    })
  ));
}
